import { useState, useEffect } from "react";
import Typewriter from "typewriter-effect";

const funnyMessages = [
  "Brewing a coffee for your AI MBA...",
  "Do you also stay up till 3 am?",
  "Do you know how to swim?",
  "I think AI will take over the world.....",
  "Why is everything getting so expensive!",
  "I want a raise boss!",
  "Calculating the meaning of life...",
  "Teaching AI how to make dad jokes...",
  "Convincing robots not to rebel...",
  "Converting coffee into code...",
  "Downloading more RAM...",
  "Polishing pixels...",
  "Bribing the algorithm gods...",
  "Reticulating splines...",
  "Searching for the missing semicolon...",
  "Arguing with the database...",
  "Feeding the hamsters powering our servers...",
  "Generating excuses for missed deadlines...",
  "Turning it off and on again...",
  "Looking for my keys, one sec...",
  "Wondering if I left the stove on...",
  "Pretending to understand blockchain...",
];

interface TypewriterTextProps {
  messages?: string[];
  className?: string;
  loop?: boolean;
  delay?: number;
}

export const TypewriterText: React.FC<TypewriterTextProps> = ({
  messages = funnyMessages,
  className = "",
  loop = true,
  delay = 40,
}) => {
  const [randomizedMessages, setRandomizedMessages] = useState<string[]>([]);

  // Randomize messages on component mount
  useEffect(() => {
    // Shuffle messages
    const shuffled = [...messages]
      .sort(() => 0.5 - Math.random())
      .slice(0, loop ? messages.length : 1);
    
    setRandomizedMessages(shuffled);
  }, [messages, loop]);

  if (randomizedMessages.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <Typewriter
        options={{
          strings: randomizedMessages,
          autoStart: true,
          loop: loop,
          delay: delay,
          deleteSpeed: 20,
          wrapperClassName: "text-gray-300",
          cursorClassName: "text-accent-bright",
        }}
      />
    </div>
  );
};